import React, { useState, useRef, useEffect } from "react";
import { get } from "lodash";
import Avatar from "@/assets/images/svg/avatar6.svg";
import "./style.scss";

const UserDropdown = ({ profile, lockHandler }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="cm-dropdown" ref={dropdownRef}>
      <div className="cm-dropdown-label" onClick={() => setOpen(!open)}>
        <img
          src={get(profile, "photo.thumbnails.small.src", Avatar)}
          alt="User avatar"
        />
      </div>

      {open && (
        <div className="cm-dropdown-list-wrapper">
          <div className="cm-dropdown-list">
            <div className="user-info">
              <p>
                <span className="label">Имя:</span>{" "}
                <span className="value">{get(profile, "name", "-")}</span>
              </p>
              <p>
                <span className="label">Должность:</span>{" "}
                <span className="value">{get(profile, "role.role", "-")}</span>
              </p>
            </div>

            <div className="cm-dropdown-actions">
              <div className="cm-dropdown-item logout" onClick={lockHandler}>
                Выйти
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDropdown;
